var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 24,
    viewBox: "0 0 24 24",
    width: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.0001 22c-1.5119.0043-3.00478-.3378-4.364-1-.49745-.242-.97407-.5246-1.425-.845l-.137-.1c-1.24018-.9154-2.25413-2.1028-2.964-3.471-.73426-1.4161-1.11509-2.9888-1.11005-4.584 0-5.52285 4.4772-10 10.00005-10 5.5228 0 10 4.47715 10 10 .005 1.5944-.3754 3.1664-1.109 4.582-.7089 1.3674-1.7214 2.5544-2.96 3.47-.4672.342-.9631.6431-1.482.9l-.08.04c-1.3601.6657-2.8547 1.0106-4.369 1.008zm0-5c-1.4985-.0029-2.87234.834-3.557 2.167 2.2414 1.1102 4.8726 1.1102 7.114 0v-.005c-.6855-1.3315-2.0594-2.1666-3.557-2.162zm0-2c2.1661.0028 4.1634 1.1701 5.229 3.056l.015-.013.014-.012-.017.015-.01.008c2.529-2.1849 3.4333-5.7117 2.2676-8.84389-1.1656-3.13223-4.1555-5.20979-7.4976-5.20979-3.34209 0-6.33201 2.07756-7.49765 5.20979-1.16564 3.13219-.26135 6.65899 2.26765 8.84389 1.06626-1.885 3.06336-3.0514 5.229-3.054zm0-1c-2.20914 0-4-1.7909-4-4 0-2.20914 1.79086-4 4-4 2.2091 0 4 1.79086 4 4 0 1.0609-.4214 2.0783-1.1716 2.8284-.7501.7502-1.7675 1.1716-2.8284 1.1716zm0-6c-1.1046 0-2 .89543-2 2 0 1.1046.8954 2 2 2s2-.8954 2-2c0-1.10457-.8954-2-2-2z",
    fill: "#4f4f4f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserCircle);
export default __webpack_public_path__ + "static/media/user_circle.39a935d133baffbded251080847da091.svg";
export { ForwardRef as ReactComponent };